import React, { useState, useEffect } from 'react';
import { Container, Row, Col } from "react-bootstrap";
import { useLocation,useNavigate } from 'react-router-dom'; // Import useLocation hook
import MoliAPICall from "../services/MoliAPICall";
import APICall from '../services/ApiCall';
 
const Session = () => {
    const location = useLocation(); // Access the current location
    const [data, setData] = useState(null);
    const navigate = useNavigate();
    
    const [userName, setUserName] = useState('');
    const [selectedLanguage, setSelectedLanguage] = useState("English");
 
    useEffect(() => {
        const queryParams = new URLSearchParams(location.search);
        const sessionId = queryParams.get('sessionId'); // Get sessionId from query params
        const jobId = queryParams.get('jobId'); // Get jobId from query params
        fetchJobData(jobId);
       
    }, [location]); // Re-run the effect when location changes
 
    // Fetch job data using MoliAPICall
    const fetchJobData = async (jobId) => {
        const moliAPI = new MoliAPICall(); // Create an instance of MoliAPICall
        try {
            const data = await moliAPI.fetchJobData(jobId); // Call the fetchJobData method on the instance
            console.log(data); // Store the fetched job data in state
            setData(data);
        } catch (error) {
            console.error("Error fetching job data:", error);
        }
    };
    // Handle form submission
    // const handleEnterRoom = () => {
    //     if (username) {
    //         navigate(`/room?sessionId=${location.search.split('=')[1]}&username=${username}`);
    //     } else {
    //         alert('Please enter your name and select a language.');
    //     }
    // };
    const handleSubmit = async () => {
        if (!userName) {
          alert("Please enter name.");
          return;
        }
   
        // const queryParams = new URLSearchParams(location.search);
        // const sessionId = queryParams.get('sessionId');
        const currentTime = new Date().toISOString();
 
        // Determine source and target language codes based on selection
        const sourceLanguageCode = selectedLanguage === "English" ? "en-US" : data.job_details.azure_code;
        const targetLanguageCode = selectedLanguage === "English" ? data.job_details.azure_code : "en-US";
   
        const payload = [
            {
              user_name: userName,
              session_id: 'z4mb5c',
              designation: 'User',
              join_time: currentTime
            }
          ];
        console.log("payload is:", payload);
 
        const attendeeInfo = {
            userName,
            sourceLanguageCode,
            targetLanguageCode
          };
          console.log("attendeeInfo is:", attendeeInfo);
          document.cookie = `attendeeInfo=${JSON.stringify(attendeeInfo)}; path=/; max-age=21600`; // Expiry in 1 day  
   
        try {
            const apiCall = new APICall();
            const response = await apiCall.postAttedendee(payload);
            console.log("Attendee added successfully:", response);
            navigate(`/room?sessionId=${location.search.split('=')[1]}&username=${userName}`);
        } catch (error) {
          console.error("Error posting attendee data:", error);
        }
      };
 
    return (
        <Container
        style={{
            // display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
            alignItems: 'center',
            height: '100vh',
            backgroundColor: '#f8f9fa',
            marginTop: '5%',
            marginBottom: '5%'
        }}
        >
            <Row className="justify-content-center mt-4">
                <Col  className="text-center">
                    <label
                        htmlFor="name"
                        style={{
                            display: 'block',
                            marginBottom: '15px',
                            fontSize: '22px',
                            color: 'black',
                            marginTop: '40px',
                            textAlign:'center'
                        }}
                    >
                        Enter your name..!
                    </label>
                    <div style={{ display: 'flex', justifyContent: 'center' }}>
                        <input
                            type="text"
                            id="name"
                            onChange={(e) => setUserName(e.target.value)} // Update username on change
                            placeholder="Enter name"
                            style={{
                                width: '30%',
                                padding: '10px',
                                marginBottom: '15px',
                                fontSize: '20px',
                                color: 'black',
                                backgroundColor: 'white',
                                border: '1px solid grey',
                                borderRadius: '5px',
                            }}
                        />
                    </div>

                    <label
                        htmlFor="language"
                        style={{
                            display: 'block',
                            marginBottom: '15px',
                            fontSize: '22px',
                            color: 'black',
                            textAlign:'center'
                        }}
                    >
                        Select your language..!
                    </label>
 
                    {/* Radio buttons in the same row */}
                    <div style={{ display: 'flex', justifyContent:'center', gap: '20px', marginBottom: '15px', left: '50%', }}>
                        <div style={{ display: 'flex', alignItems: 'center' }}>
                            <input
                                type="radio"
                                id="english"
                                value="English"
                                name="language"
                                style={{
                                    marginRight: '10px',
                                    fontSize: '20px',
                                }}
                            />
                            <label htmlFor="english" style={{ fontSize: '18px', color:'black' }}>English</label>
                        </div>
 
                        <div style={{ display: 'flex', alignItems: 'center' }}>
                            <input
                                type="radio"
                                id="spanish"
                                value="secondLang"
                                name="language"
                                style={{
                                    marginRight: '10px',
                                    fontSize: '20px'
                                }}
                            />
                            <label htmlFor="2ndLang" style={{ fontSize: '18px', color:'black' }}>{data && data.job_details ? data.job_details.language_name : 'Language'}</label>
                        </div>
                    </div>
 
                    <div style={{ display: 'flex', justifyContent: 'center', marginTop: '20px' }}>
                        <button
                            type="button"
                            className="btn btn-primary"
                            style={{
                                padding: '0px 20px',
                                fontSize: '20px',
                                width: '20%',
                                height: '40px',
                            }}
                            onClick={handleSubmit}
                        >
                            Enter the Room
                        </button>
                    </div>

                </Col>
 
                {/* Horizontal Rule (HR) with margin */}
                <hr style={{
                    margin: '30px 0',
                    borderTop: '2px solid #ccc',
                }} />        
 
                <Col xs={12} md={6} style={{ textAlign: 'center' }}>
                    <label
                        htmlFor="eventDetails"
                        style={{
                            display: 'block',
                            marginBottom: '15px',
                            fontSize: '22px',
                            color: '#382454'
                        }}
                    >
                        Event Details
                    </label>
 
                    <div style={{ display: 'flex', justifyContent:'center', gap: '20px', marginBottom: '15px' }}>
                        <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', marginBottom: '15px' }}>
                            <label
                                htmlFor="eventDate"
                                style={{
                                    display: 'block',
                                    marginBottom: '5px',
                                    fontSize: '18px',
                                    color: 'black'
                                }}
                            >
                                Event Date
                            </label>
                            <span style={{ fontSize: '18px', color: '#8c8b8b', textAlign:'center' }}>
                                {data ? new Date(data.event_details.occurrence_event_date).toLocaleDateString('en-IN', {
                                    year: 'numeric',
                                    month: 'long',
                                    day: 'numeric'
                                }) : 'NA'}
                            </span>
 
                        </div>
 
                        <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', marginBottom: '15px' }}>
                            <label
                                htmlFor="Time"
                                style={{
                                    display: 'block',
                                    marginBottom: '5px',
                                    fontSize: '18px',
                                    color: 'black'
                                }}
                            >
                                Time
                            </label>
                            <span style={{ fontSize: '18px', color: '#8c8b8b' }}>
                                {data && data.event_details && data.event_details.event_start_time
                                    ? data.event_details.event_start_time.substring(0, 5)
                                    : 'NA'}
                            </span>
 
                        </div>
 
                        <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', marginBottom: '15px' }}>
                            <label
                                htmlFor="courtRoom"
                                style={{
                                    display: 'block',
                                    marginBottom: '5px',
                                    fontSize: '18px',
                                    color: 'black'
                                }}
                            >
                                Court Room
                            </label>
                            <span style={{ fontSize: '18px', color: '#8c8b8b' }}>
                                {data && data.event_details && data.event_details.courtroom_name
                                    ? data.event_details.courtroom_name
                                    : 'NA'}
                            </span>
 
                        </div>
 
                        <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', marginBottom: '15px' }}>
                            <label
                                htmlFor="hearingType"
                                style={{
                                    display: 'block',
                                    marginBottom: '5px',
                                    fontSize: '18px',
                                    color: 'black'
                                }}
                            >
                                Hearing Type
                            </label>
                            <span style={{ fontSize: '18px', color: '#8c8b8b' }}>
                                {data && data.event_details && data.event_details.hearing_type
                                    ? data.event_details.hearing_type
                                    : 'NA'}
                            </span>
 
                        </div>

                        <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', marginBottom: '15px' }}>
                            <label
                                htmlFor="judge"
                                style={{
                                    display: 'block',
                                    marginBottom: '5px',
                                    fontSize: '18px',
                                    color: 'black'
                                }}
                            >
                                Judge
                            </label>
                            <span style={{ fontSize: '18px', color: '#8c8b8b' }}>
                                {data && data.event_details && data.event_details.judge_name
                                    ? data.event_details.judge_name
                                    : 'NA'}
                            </span>
 
                        </div>
 
                        <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', marginBottom: '15px' }}>
                            <label
                                htmlFor="eventTitle"
                                style={{
                                    display: 'block',
                                    marginBottom: '5px',
                                    fontSize: '18px',
                                    color: 'black'
                                }}
                            >
                                Event Title
                            </label>
                            <span style={{ fontSize: '18px', color: '#8c8b8b' }}>
                                {data && data.event_details && data.event_details.event_title
                                    ? data.event_details.event_title
                                    : 'NA'}
                            </span>
 
                        </div>
 
                        <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', marginBottom: '15px' }}>
                            <label
                                htmlFor="eventDescription"
                                style={{
                                    display: 'block',
                                    marginBottom: '5px',
                                    fontSize: '18px',
                                    color: 'black'
                                }}
                            >
                                Event Description
                            </label>
                            <span style={{ fontSize: '18px', color: '#8c8b8b' }}>
                                {data && data.event_details && data.event_details.event_description
                                    ? data.event_details.event_description
                                    : 'NA'}
                            </span>
                        </div>
                    </div>  
                   
                    {/* Horizontal Rule (HR) with margin */}
                    <hr style={{
                        margin: '30px 0',
                        borderTop: '2px solid #ccc',
                    }} />
 
                    <label
                        htmlFor="jobDetails"
                        style={{
                            display: 'block',
                            marginBottom: '15px',
                            fontSize: '22px',
                            color: '#382454'
                        }}
                    >
                        Job Details
                    </label>
 
                    <div style={{ display: 'flex', justifyContent:'center', gap: '30px', marginBottom: '15px', marginLeft:'2%' }}>
                        <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', marginBottom: '15px' }}>
                            <label
                                htmlFor="language"
                                style={{
                                    display: 'block',
                                    marginBottom: '5px',
                                    fontSize: '18px',
                                    color: 'black'
                                }}
                            >
                                Language
                            </label>
                            <span style={{ fontSize: '18px', color: '#8c8b8b' }}>
                                {data && data.job_details && data.job_details.language_name
                                    ? data.job_details.language_name
                                    : 'NA'}
                            </span>
 
                        </div>
 
 
                        <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', marginBottom: '15px' }}>
                            <label
                                htmlFor="modality"
                                style={{
                                    display: 'block',
                                    marginBottom: '5px',
                                    fontSize: '18px',
                                    color: 'black'
                                }}
                            >
                                Modality
                            </label>
                            <span style={{ fontSize: '18px', color: '#8c8b8b' }}>
                                {data && data.job_details && data.job_details.modality_name
                                    ? data.job_details.modality_name
                                    : 'NA'}
                            </span>
 
                        </div>
                    </div>
                   
                   
 
                    <div style={{
                        border: '2px solid #ccc',
                        borderRadius: '10px',
                        padding: '20px',
                        marginBottom: '20px',
                        backgroundColor: '#f9f9f9'
                    }}>
                        <label
                            htmlFor="cases"
                            style={{
                                display: 'block',
                                marginBottom: '15px',
                                fontSize: '22px',
                                color: '#382454'
                            }}
                        >
                            Cases
                        </label>
 
                        <div style={{ display: 'flex', justifyContent:'center', gap: '50px', marginBottom: '15px' }}>
                            <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', marginBottom: '15px' }}>
                                <label
                                    htmlFor="caseType"
                                    style={{
                                        display: 'block',
                                        marginBottom: '5px',
                                        fontSize: '18px',
                                        color: 'black'
                                    }}
                                >
                                    Case Type
                                </label>
                                <span style={{ fontSize: '18px', color: '#8c8b8b' }}>
                                    {data && data.cases && data.cases[0].case_type
                                        ? data.cases[0].case_type  
                                        : 'NA'}
                                </span>
                            </div>
                            <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', marginBottom: '15px' }}>
                                <label
                                    htmlFor="caseTitle"
                                    style={{
                                        display: 'block',
                                        marginBottom: '5px',
                                        fontSize: '18px',
                                        color: 'black'
                                    }}
                                >
                                    Case Title
                                </label>
                                <span style={{ fontSize: '18px', color: '#8c8b8b' }}>
                                    {data && data.cases && data.cases[0].case_title
                                        ? data.cases[0].case_title
                                        : 'NA'}
                                </span>
                            </div>
                            <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', marginBottom: '15px' }}>
                                <label
                                    htmlFor="caseLanguage"
                                    style={{
                                        display: 'block',
                                        marginBottom: '5px',
                                        fontSize: '18px',
                                        color: 'black'
                                    }}
                                >
                                    Language
                                </label>
                                <span style={{ fontSize: '18px', color: '#8c8b8b' }}>
                                    {data && data.job_details && data.job_details.language_name
                                        ? data.job_details.language_name
                                        : 'NA'}
                                </span>
                            </div>
                            <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', marginBottom: '15px' }}>
                                <label
                                    htmlFor="attorneyName"
                                    style={{
                                        display: 'block',
                                        marginBottom: '5px',
                                        fontSize: '18px',
                                        color: 'black'
                                    }}
                                >
                                    Attorney Name
                                </label>
                                <span style={{ fontSize: '18px', color: '#8c8b8b' }}>
                                    {data && data.cases && data.cases[0].attorney_name
                                        ? data.cases[0].attorney_name
                                        : 'NA'}
                                </span>
                            </div>
                            <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', marginBottom: '15px' }}>
                                <label
                                    htmlFor="lepName"
                                    style={{
                                        display: 'block',
                                        marginBottom: '5px',
                                        fontSize: '18px',
                                        color: 'black'
                                    }}
                                >
                                    LEP Name
                                </label>
                                <span style={{ fontSize: '18px', color: '#8c8b8b' }}>
                                    {data && data.cases && data.cases[0].lep_person_name
                                        ? data.cases[0].lep_person_name
                                        : 'NA'}
                                </span>
                            </div>
                        </div>
                    </div>
                </Col>
            </Row>
        </Container>
    );
};
 
export default Session;
 
 